
import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Supporters } from "../components/home/Supporters";

const Soutiens = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="py-12">
        <div className="container mx-auto">
          <h1 className="text-4xl font-bold text-center mb-12">Nos Soutiens</h1>
          <Supporters />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Soutiens;
